<span>
  <a href="{{ url }}" target="_blank">{{ name }}</a>
</span>
